import ProductCoverImage from './ProductCoverImage';

export default ProductCoverImage;
